import { render, staticRenderFns } from "./MailThreads.vue?vue&type=template&id=3a977d40"
import script from "./MailThreads.vue?vue&type=script&lang=js"
export * from "./MailThreads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports